import { createReducer, on } from '@ngrx/store';
import { addInnerPackage, addOverpackSuccess, addSinglePackage, assignOverpackSuccess, createTempPackage, deletePackage, duplicateCompositePackageSuccess, duplicateInnerPackage, duplicateSinglePackageSuccess, init, initializeInnerPackageSuccess, initializeSinglePackageSuccess, loadPackagesSuccess, loadPackagingTypes, loadPackagingTypesBulkSuccess, loadPackagingTypesSuccess, loadPackagingTypesTankSuccess, loadUnPackagingTypesSuccess, removeCompositePackageSuccess, removeInnerPackage, removeOverpackSuccess, removeSinglePackageSuccess, resetPackagingTypes, saveCompositePackageSuccess, saveCompositePackageUpdateSuccess, saveSinglePackageSuccess, saveSinglePackageUpdateSuccess, setTempOverpack, updateInnerPackage, updateOverpackSuccess, updateTmpPackage } from './package-list.actions';
import { Packages, PackagingType, CompositePackagingModel } from '@hazmatsuite-next/easydgd-lib';

export const initialState = {
  packages: new Packages(),
  tempPackage: {},
  tempOverPackage: {},
  packagingTypes: [] as PackagingType[],
  packagingUnCodes: [] as PackagingType[],
  packagingTypesTank: [] as PackagingType[],
  packagingTypesBulk: [] as PackagingType[],
  packagingTypesLoaded: false,
};

export const packageListReducer = createReducer(
  initialState,
  on(init, (state, { packages }) => ({
    ...state,
    packages: packages
  })),
  on(resetPackagingTypes, (state) => ({
    ...state,
    packagingTypes: [],
    packagingUnCodes: [],
    packagingTypesLoaded: false
  })),
  on(createTempPackage, (state, { tempPackage }) => ({
    ...state,
    tempPackage: tempPackage
  })),
  on(initializeSinglePackageSuccess, (state, { pkg }) => ({
    ...state,
    tempPackage: pkg
  })),
  on(initializeInnerPackageSuccess, (state, { pkg }) => ({
    ...state,
    tempPackage: {
      ...state.tempPackage,
      CurrentInnerPackaging: pkg
    }
  })),
  on(addInnerPackage, (state, { pkg }) => ({
    ...state,
    tempPackage: {
      ...state.tempPackage,
      Items: [...(state.tempPackage as CompositePackagingModel).Items, pkg],
      CurrentInnerPackaging: null
    }
  })),
  on(updateInnerPackage, (state, { pkg }) => ({
    ...state,
    tempPackage: {
      ...state.tempPackage,
      Items: [...(state.tempPackage as CompositePackagingModel).Items.map(item => {
        if (item.InternalId === pkg.InternalId) {
          return pkg;
        }
        return item;
      })],
      CurrentInnerPackaging: null
    }
  })),
  on(removeInnerPackage, (state, { internalId }) => ({
    ...state,
    tempPackage: {
      ...state.tempPackage,
      Items: [...(state.tempPackage as CompositePackagingModel).Items.filter(item => item.InternalId !== internalId)],
    }
  })),
  on(duplicateInnerPackage, (state, { pkg }) => ({
    ...state,
    tempPackage: {
      ...state.tempPackage,
      Items: [...(state.tempPackage as CompositePackagingModel).Items, { ...pkg }],
    }
  })),
  on(updateTmpPackage, (state, { tempPackage }) => ({
    ...state,
    tempPackage: tempPackage
  })),
  on(addSinglePackage, (state, { newPackage }) => ({
    ...state,
    packages: {
      ...state.packages,
      SinglePackagingItems: [
        ...state.packages.SinglePackagingItems,
        newPackage
      ]
    }
  })),
  on(deletePackage, (state) => initialState),
  on(loadPackagesSuccess, (state, { packages }) => ({
    ...state,
    packages: packages
  })),
  on(loadPackagingTypes, (state) => ({
    ...state,
    packagingTypesLoaded: true
  })),
  on(loadPackagingTypesSuccess, (state, { packagingTypes }) => ({
    ...state,
    packagingTypes: packagingTypes
  })),
  on(loadUnPackagingTypesSuccess, (state, { unPackagingTypes }) => ({
    ...state,
    packagingUnCodes: unPackagingTypes
  })),
  on(loadPackagingTypesTankSuccess, (state, { packagingTypes }) => ({
    ...state,
    packagingTypesTank: packagingTypes
  })),
  on(loadPackagingTypesBulkSuccess, (state, { packagingTypes }) => ({
    ...state,
    packagingTypesBulk: packagingTypes
  })),
  on(saveSinglePackageSuccess, (state, { pkg }) => ({
    ...state,
    packages: {
      ...state.packages,
      SinglePackagingItems: [...state.packages.SinglePackagingItems, pkg]
    }
  })),
  on(saveSinglePackageUpdateSuccess, (state, { pkg }) => ({
    ...state,
    packages: {
      ...state.packages,
      SinglePackagingItems: [...state.packages.SinglePackagingItems.map(item => {
        if (item.Id === pkg.Id) {
          return { ...pkg };
        }
        return { ...item };
      })]
    }
  })),
  on(duplicateSinglePackageSuccess, (state, { pkg }) => ({
    ...state,
    packages: {
      ...state.packages,
      SinglePackagingItems: [...state.packages.SinglePackagingItems, pkg]
    }
  })),
  on(removeSinglePackageSuccess, (state, { id }) => ({
    ...state,
    packages: {
      ...state.packages,
      SinglePackagingItems: [...state.packages.SinglePackagingItems.filter(p => p.Id !== id)]
    }
  })),
  on(saveCompositePackageSuccess, (state, { pkg }) => ({
    ...state,
    packages: {
      ...state.packages,
      CompositePackagingItems: [...state.packages.CompositePackagingItems, pkg]
    }
  })),
  on(saveCompositePackageUpdateSuccess, (state, { pkg }) => ({
    ...state,
    packages: {
      ...state.packages,
      CompositePackagingItems: [...state.packages.CompositePackagingItems.map(item => {
        if (item.Id === pkg.Id) {
          return { ...pkg };
        }
        return { ...item };
      })]
    }
  })),
  on(duplicateCompositePackageSuccess, (state, { pkg }) => ({
    ...state,
    packages: {
      ...state.packages,
      CompositePackagingItems: [...state.packages.CompositePackagingItems, pkg]
    }
  })),
  on(removeCompositePackageSuccess, (state, { id }) => ({
    ...state,
    packages: {
      ...state.packages,
      CompositePackagingItems: [...state.packages.CompositePackagingItems.filter(p => p.Id !== id)]
    }
  })),
  on(addOverpackSuccess, (state, { pkg }) => ({
    ...state,
    packages: {
      ...state.packages,
      OverpackPackagingItems: [
        ...state.packages.OverpackPackagingItems,
        pkg
      ]
    }
  })),
  on(assignOverpackSuccess, (state, { packageId, overpackId }) => ({
    ...state,
    packages: {
      ...state.packages,
      CompositePackagingItems: [...state.packages.CompositePackagingItems.map(item => {
        if (item.Id === packageId) {
          return {
            ...item,
            ParentId: overpackId
          };
        }
        return { ...item };
      })],
      SinglePackagingItems: [...state.packages.SinglePackagingItems.map(item => {
        if (item.Id === packageId) {
          return {
            ...item,
            ParentId: overpackId
          };
        }
        return { ...item };
      })],
    }
  })),
  on(updateOverpackSuccess, (state, { pkg }) => ({
    ...state,
    packages: {
      ...state.packages,
      OverpackPackagingItems: [
        ...state.packages.OverpackPackagingItems.map(item => {
          if (item.Id === pkg.Id) {
            return {
              ...pkg
            }
          }
          return {
            ...item
          };
        })
      ]
    }
  })),
  on(setTempOverpack, (state, { pkg }) => ({
    ...state,
    tempOverPackage: pkg
  })),
  on(removeOverpackSuccess, (state, { pkg }) => ({
    ...state,
    packages: {
      ...state.packages,
      OverpackPackagingItems: [...state.packages.OverpackPackagingItems.filter(i => i.Id !== pkg.Id)],
      CompositePackagingItems: [...state.packages.CompositePackagingItems.filter(i => i.ParentId !== pkg.Id)],
      SinglePackagingItems: [...state.packages.SinglePackagingItems.filter(i => i.ParentId !== pkg.Id)],
    }
  }))
);
